// import { PropsWithChildren } from 'react';
import { PropsWithChildren } from 'react';
import { MuiProvider } from './mui-provider';
import { OldMuiProvider } from './old-mui-provider';
import { TanStackQueryProvider } from './tanstack-query-provider';
import { Toaster } from './toaster';
import { Outlet } from 'react-router';

export function Providers() {
  return (
    <MuiProvider>
      <TanStackQueryProvider>
        <Toaster />
        <Outlet />
      </TanStackQueryProvider>
    </MuiProvider>
  );
}

export function OldProviders({ children }: PropsWithChildren) {
  return <OldMuiProvider>{children}</OldMuiProvider>;
}
